import { Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { Subscription, combineLatest } from 'rxjs';
import { ControlPageService } from '../control-page.service';

@Component({
  selector: 'app-control-page-main',
  templateUrl: './control-page-main.component.html',
  styleUrls: ['./control-page-main.component.scss']
})
export class ControlPageMainComponent {

  subscrition =  new Subscription();

  constructor(
    private homesFacade: HomesFacade,
    private controlPageService: ControlPageService,
  ) {

  }
  ngOnInit() {
    this.subscrition.add(combineLatest({
      homeId: this.homesFacade.currentHomeId$,
      hasHome: this.controlPageService.hasHome$,
      hasModules: this.controlPageService.hasModules$,
      hasUnplacedProducts: this.controlPageService.hasUnplacedProducts$,
      hasThermostatOrValve: this.controlPageService.hasThermostatOrValve$,
    }).subscribe(({hasHome, hasModules, hasUnplacedProducts, hasThermostatOrValve}) => {
      this.controlPageService.controlPageGetRoute(hasHome, hasModules, hasUnplacedProducts, hasThermostatOrValve);
    }));
  }
}
